import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

// Конфигурация Firebase (замените на свои данные из Firebase Console)
const firebaseConfig = {
  apiKey: "AIzaSyCuoCcDkLKZo5DsNu_2WDiYo3pZW3n1-BI",
  authDomain: "duh-primorya.firebaseapp.com",
  projectId: "duh-primorya",
  storageBucket: "duh-primorya.firebasestorage.app",
  messagingSenderId: "161742091008",
  appId: "1:161742091008:web:3cc32ccb376567edd079e5",
  measurementId: "G-D6Z86V3TV5"
};

// Инициализация Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
